export enum UsageType {
  Processing = "processing",
  ECA = "eca",
  Review = "review"
}
